import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../core/services/config.service';
import { fuseAnimations } from '../../../core/animations';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { FuseNavigationService } from '../../../core/components/navigation/navigation.service';
import { FuseNavigationModel } from '../../navigation/navigation.model';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: fuseAnimations
})
export class FuseLoginComponent implements OnInit {
    loginForm: FormGroup;
    loginFormErrors: any;
    recordarUser: boolean;
    loading = false;

    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        private router: Router,
        private loginService: LoginService,
        private constantesService: ConstantesService,
        private fuseNavigationService: FuseNavigationService,
        private notificacion: NotificacionesService,
        private translate: TranslateService
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });
        this.loginFormErrors = {
            usuario: {},
            password: {}
        };
        // Por defecto a true?
        this.recordarUser = true;
    }

    ngOnInit() {
        // Si le dio a recordar usuario, se le pone automaticamente
        this.loginForm = this.formBuilder.group({
            usuario: [localStorage.getItem('userBim') ? localStorage.getItem('userBim') : '', Validators.required],
            password: ['', Validators.required]
        });

        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });
    }

    onLoginFormValuesChanged() {
        for (const field in this.loginFormErrors) {
            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }

    logIn(usuario: string, password: string) {
        this.loading = true;
        if (this.recordarUser) {
            // Si usuario marca check, se guarda el nombre de usuario en localStorage.
            localStorage.setItem('userBim', usuario);
        }
        this.loginService.getToken(usuario, password).subscribe(
            data => {
                if (data.access_token) {
                    // Se guarda el token del usuario en sessionStorage (se utiliza para cambiar headers al descargar PDF en fileManager).
                    sessionStorage.setItem('tokenBim', data.access_token);
                    this.constantesService.refrescarHeaders(); // Tengo que hacer esto al obtener el token
                    // Antes de dirigirme al mapa, obtengo los datos del usuario que se ha logueado
                    this.loginService.getUserLogueado().subscribe(
                        data2 => {
                            if (data2.success) {
                                // Meto aqui el usuario
                                sessionStorage.setItem('usuarioLogueado', JSON.stringify({ 'usuario': data2.items }));
                                // Cargo el menu
                                // Set the navigation model
                                this.fuseNavigationService.setNavigationModel(new FuseNavigationModel(this.translate));
                                // Como todo ha ido bien, nos vamos para dentro
                                this.router.navigate(['/portfolio']);
                            } else {
                                // MENSAJE DE ERROR
                                this.loading = false;
                                this.notificacion.mostrarAviso(this.notificacion.mensajes.IdiomaActual.MensajesGenerales.ErrorDesconocido);
                            }
                        },
                        err2 => {
                            // MENSAJE DE ERROR
                            this.loading = false;
                            this.notificacion.errorServidor(err2.status);
                        }
                    );

                } else {
                    // MENSAJE DE ERROR
                    this.loading = false;
                    this.notificacion.mostrarAviso(this.notificacion.mensajes.IdiomaActual.MensajesGenerales.ErrorDesconocido);
                }

            },
            () => {
                // MENSAJE DE ERROR
                this.loading = false;
                this.notificacion.mostrarAviso(this.notificacion.mensajes.IdiomaActual.Login.CredencialesInvalidas);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/login/login.component.ts